import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Box from '@material-ui/core/Box';
import { H1 } from 'shared-assets/components/Elements';
var FriendlyErrorPage = function () {
    return (React.createElement(Box, { alignItems: "center", display: "flex", flexDirection: "column", height: "100vh", justifyContent: "center" },
        React.createElement(Card, { style: { width: '50%' } },
            React.createElement(CardContent, null,
                React.createElement(H1, null, "Oops, something went wrong with video session link"),
                React.createElement("p", null, "Please try the link again!")))));
};
export default FriendlyErrorPage;
